// GENERATED CODE - DO NOT EDIT
export const ConfirmationTypeMap = {
    DATE_AND_TIME: 'DATE_AND_TIME',
    ADDRESS: 'ADDRESS',
    PATIENT_PAY: 'PATIENT_PAY',
    HOME_TO_SIGN: 'HOME_TO_SIGN',
};
//# sourceMappingURL=confirmation_type.js.map